module.exports = __webpack_public_path__ + "media/country_flags/md-5e438770.png";